var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.localValue)?_c('v-color-picker',_vm._b({attrs:{"value":_vm.localValue,"hide-canvas":"","hide-slidersx":"","hide-inputsx":"","show-swatches":"","swatches-max-height":"300px"},on:{"input":_vm.onInput}},'v-color-picker',_vm.$attrs,false)):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }